import MiniChallenges from './routes/challenges'

export default [...MiniChallenges]
